<template>
    <div id="container" type="vrefinancerates">
        <div class="page page-refinancerates" v-ga:request="{pageType:'vrefinancerates', state: {}}" v-ga:page="{pageType:'vrefinancerates', glb: glb, state: {}}">
            <mvtHeader />
            <section class="inline large">
                <div class="fixed fixed-max-sm grid xs-grid-cols-1 gap-3">
                    <div class="text-center wrap">
                        <h1><b class="f1 text-bold">Compare Today’s Refinance Rates</b></h1>
                        <div>Find and Compare Today’s Refinance Rates</div>
                    </div>
                    <compareRates v-bind:default-rate-type="defaultRateType" />
                </div>
            </section>

            <section class="inline large">
                <mvtLazyload>
                    <mvtRateTrend></mvtRateTrend>
                </mvtLazyload>
            </section>

            <mortgageTools :id="glb.pageType" preTitle="EXPERT GUIDANCE AND RESOURCES" title="Tools for every step of your real estate journey"></mortgageTools>

            <section class="inline large">
                <div class="grid xs-grid-cols-1 fixed fixed-max-sm gap-3">
                    <div class="text-center">
                        <h2>
                            <b class="f3 text-bold">Frequently Asked Questions</b>
                        </h2>
                    </div>
                    <mvtFaq v-if="faqQuery" :query="faqQuery"></mvtFaq>
                </div>
            </section>

            <section class="inline large" v-if="tag">
                <div class="grid xs-grid-cols-1 fixed fixed-max-sm gap-3">
                    <div class="text-center">
                        <h2>
                            <b class="f3 text-bold">Related Articles</b>
                        </h2>
                    </div>
                    <mvtArticle :tag="tag" />
                </div>
            </section>
            <mvtFooter />
        </div>
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-refinancerates.js"></script>
